let localUnreadCount = null;
let lastLocalChangeAt = 0;
async function fetchNotifications() {
  try {
    const response = await fetch('/report_downloads/notifications');
    const data = await response.json();

    const list = document.getElementById('notifications-list');
    const count = document.getElementById('unread-count');

    const now = Date.now();
    const SAFE_WINDOW = 5000; // 5 seconds
    if (!list || !count) return false;

    // initialize or update local state
    if (localUnreadCount === null) {
      localUnreadCount = data.unread_count;
    } else if (now - lastLocalChangeAt > SAFE_WINDOW) {
      localUnreadCount = data.unread_count;
    }

    // draw badge based on local state 
    if (localUnreadCount > 0) {
      count.textContent = localUnreadCount;
      count.style.display = 'inline-block';
    } else {
      count.style.display = 'none';
    }

    list.innerHTML = '';

    const header = document.createElement('h6');
    header.className = 'dropdown-header';
    header.textContent = 'Sin Notificaciones';
    list.appendChild(header);

    let hasNotification = false;

    if (data.notifications.length > 0) {
      data.notifications.forEach(notif => {
        if (notif.url) hasNotification = true;

        const a = document.createElement('a');
        a.className = 'dropdown-item d-flex align-items-center notif-item';
        a.href = notif.url || '#';
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.dataset.notifId = notif.id;
        a.innerHTML = `
          <div class="mr-3"><i data-feather="info"></i></div>
          <div>
            <div class="small text-gray-500">${notif.created_at}</div>
            <span>${notif.message}</span>
          </div>
        `;
        list.appendChild(a);
      });
    } else {
      const span = document.createElement('span');
      span.className = 'dropdown-item text-center small text-gray-500';
      span.textContent = 'No tienes notificaciones';
      list.appendChild(span);
    }

    if (window.feather) feather.replace();

    return hasNotification;
  } catch (error) {
    console.error('Error fetching notifications:', error);
    return false;
  }
}

function startPollingNotifications() {
  let intervalCount = 0;
  const maxIntervals = 30;
  const intervalTime = 30000;

  fetchNotifications(); // fetch on start

  const intervalId = setInterval(async () => {
    if (intervalCount >= maxIntervals) {
      clearInterval(intervalId);
    } else {
      await fetchNotifications();
      intervalCount++;
    }
  }, intervalTime);
}

document.addEventListener('DOMContentLoaded', () => {
  fetchNotifications();
  const reportButton = document.getElementById('generate-report');
  if (reportButton) {
    reportButton.addEventListener('click', () => {
      startPollingNotifications();
    });
  }

  const list = document.getElementById('notifications-list');
  const badge = document.getElementById('unread-count');
  if (list && badge) {
    list.addEventListener('click', function(e) {
      const item = e.target.closest('.notif-item');
      if (!item) return;

      const notifId = item.dataset.notifId;

      item.remove();
      lastLocalChangeAt = Date.now();
      localUnreadCount = Math.max((localUnreadCount || 0) - 1, 0);

      if (localUnreadCount > 0) {
        badge.textContent = localUnreadCount;
        badge.style.display = 'inline-block';
      } else {
        badge.style.display = 'none';
      }
    });
  }
});